export const ECONOMY_ACTIVITY_PARAM_TYPES = {
  VAT_RATE: 'VAT_RATE',
  ECONOMY_ACTIVITY_STATE: 'ECONOMY_ACTIVITY_STATE',
  SELF_BILLING: 'SELF_BILLING',
};
